// src/components/Certificates/Certificates.js
import React from 'react';
import './Certificates.css';

// --- IMPORT YOUR ASSETS ---
// Adjusted paths based on list_dir results
import cert1 from '../../assets/About/OurStrength/service-entry-img-1.jpg (1).png';
import cert2 from '../../assets/About/OurStrength/service-entry-img-1.jpg.png';

const Certificates = () => {

  const features = [
    "Incoming, in-process & final inspections",
    "SPC & continuous process monitoring",
    "Compliance with ISO 9001:2015 & IATF 16949:2016"
  ];

  return (
    <section className="certificates-section bg-white">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT: Text Content */}
          <div className="col-lg-5 mb-5 mb-lg-0 pe-lg-5">
            <h2 className="display-5 fw-bold text-dark mb-4">
              Strict Quality & Process Control
            </h2>
            <p className="text-muted mb-5">
              Quality is embedded at every stage—from tool design to final inspection.
            </p>

            <ul className="list-unstyled">
              {features.map((item, index) => (
                <li key={index} className="d-flex align-items-center mb-4">
                  <div className="cert-icon-wrapper me-3">
                    <i className="bi bi-patch-check-fill text-orange fs-4"></i>
                  </div>
                  <span className="text-muted fw-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* RIGHT: Certificates Grid */}
          <div className="col-lg-7">
            <div className="row g-3">
              <div className="col-6">
                <div className="cert-img-box shadow-sm rounded-1 p-2 bg-white border">
                  <img src={cert1} alt="IATF Certification" className="img-fluid w-100" />
                </div>
              </div>
              <div className="col-6">
                <div className="cert-img-box shadow-sm rounded-1 p-2 bg-white border">
                  <img src={cert2} alt="ISO Certification" className="img-fluid w-100" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Certificates;